export function shortenString(text: string, char: number): string {
  if (text.length < char) {
    return text
  }
  return `${text.slice(0, char)}...`
}
